import { Fragment, h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import Feedback from '../../../../common/hoc/feedback';
import { useStyles } from '../../../../common/hooks';
import { Icon } from '../../common/svg/icons';
import {
  GEAR_TEXT_STYLE,
  ICON_SUB_TITLE_SIZE,
  TEXT_TRACK_TEXT_FEEDBACK_STYLE,
  TEXT_TRACK_TEXT_FEEDBACK_WRAPPER_STYLE
} from './styles';

const TIME_DELAY_FOR_SETTINGS_APPLIED = 2000;

function TrackFeedBack({ trackSelected, track = { index: -1 }, type, defaultIndex = -1 }) {
  const [visible, setVisible] = useState(false);
  const prevLangRef = useRef(trackSelected);
  const isTrackSettingsApplied = useRef(false);

  useEffect(() => {
    // Handle initial delay because audo|text is changed automatically in settings
    const delayTimer = setTimeout(() => {
      isTrackSettingsApplied.current = true;
    }, TIME_DELAY_FOR_SETTINGS_APPLIED);
    return () => clearTimeout(delayTimer);
  }, []);

  useEffect(() => {
    if (trackSelected !== prevLangRef.current) {
      if (isTrackSettingsApplied.current) {
        setVisible(true);
      }
      prevLangRef.current = trackSelected;
    }
  }, [trackSelected]);
  const subLabelSvgIconSize = useStyles()(ICON_SUB_TITLE_SIZE);
  const gearIconSize = useStyles()(GEAR_TEXT_STYLE);
  const textStyle = useStyles()(TEXT_TRACK_TEXT_FEEDBACK_STYLE);

  const content = track.index === defaultIndex
    ? (
      <div>
        {`${type} désactivés`}
      </div>
    )
    : (
      <Fragment>
        <div>
          {`${type} activés (`}
        </div>
        <div>{track.label.toLowerCase()}</div>
        {track?.icon && (
          <Icon
            name={track?.icon}
            width={subLabelSvgIconSize.size}
            height={subLabelSvgIconSize.size}
          />
        )}
        <div>)</div>
      </Fragment>
    );

  return visible && (
    <Feedback
      onClose={() => setVisible(false)}
      visible={visible}
      key="feedback-track"
      style={TEXT_TRACK_TEXT_FEEDBACK_WRAPPER_STYLE}
    >
      <div style={textStyle}>{content}</div>
      <div style={textStyle}>
        <div>{'Cliquer sur '}</div>
        <Icon
          name="settings"
          width={gearIconSize.size}
          height={gearIconSize.size}
        />
        <div>
          {' Paramètres pour personnaliser'}
        </div>
      </div>
    </Feedback>
  );
}

export default TrackFeedBack;
